import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from "@sentry/angular";
import { GitInfo } from './git-info';

if (environment.production) {
  enableProdMode();
}

// Force ng2-pdf-viewer to use a locally shipped worker (works offline).
// Must be set before any <pdf-viewer> is rendered.
(window as any).pdfWorkerSrc = new URL(
  'assets/scripts/pdf.worker.min.js',
  document.baseURI
).toString();

if (environment.environment != 'local' && (environment as any).sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.environment,
    sendDefaultPii: true,
    release: GitInfo.sentryRelease,
    tracesSampleRate: 0.5,
    tracePropagationTargets: [/^https:\/\/qa.crisis.interactivelife\.me/],
    integrations: [
      Sentry.browserTracingIntegration(),
      // send console.error calls as logs to Sentry
      Sentry.consoleLoggingIntegration({ levels: ["error"] }),
    ],
    // Enable logs to be sent to Sentry
    enableLogs: environment.environment == 'qa' || environment.environment == 'staging',
  });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
